import { createSlice } from "@reduxjs/toolkit"

const errorModalSlice = createSlice({
  name: "errorModal",
  initialState: {
    isOpen: false,
    errorMessage: "",
    redirectPath: null,
  },
  reducers: {
    showErrorModal: (state, action) => {
      state.isOpen = true
      state.errorMessage = action.payload.errorMessage
      state.redirectPath = action.payload.redirectPath || null
    },
    hideErrorModal: (state) => {
      state.isOpen = false
      state.errorMessage = ""
      state.redirectPath = null
    },
  },
})

export const { showErrorModal, hideErrorModal } = errorModalSlice.actions
export default errorModalSlice.reducer
